import { useEffect } from 'react'

/**
 * iOS Safari keeps the layout viewport full height when the keyboard opens and scrolls it instead, so a
 * full-screen chat would hide its composer behind the keyboard. The visual viewport is what is actually
 * visible: expose its height and offset as --app-height and --app-top for full-screen layers.
 */
export function useAppHeight(): void {
  useEffect(() => {
    const viewport = window.visualViewport
    const root = document.documentElement
    const update = () => {
      root.style.setProperty('--app-height', `${Math.round(viewport?.height ?? window.innerHeight)}px`)
      root.style.setProperty('--app-top', `${Math.round(viewport?.offsetTop ?? 0)}px`)
    }

    update()
    viewport?.addEventListener('resize', update)
    viewport?.addEventListener('scroll', update)
    window.addEventListener('resize', update)
    return () => {
      viewport?.removeEventListener('resize', update)
      viewport?.removeEventListener('scroll', update)
      window.removeEventListener('resize', update)
      root.style.removeProperty('--app-height')
      root.style.removeProperty('--app-top')
    }
  }, [])
}
